import React from 'react';
import {getStyle} from "../../services/Style";
import PropTypes from "prop-types";
import RegisterStepBreadCrumbs from "../register/RegisterStep/RegisterStepBreadCrumbs";
import Register from "../register/Register";

export default class GlobalRegisterComponent extends React.Component
{
    static propTypes = {
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string,
        language: PropTypes.string,
        customerData: PropTypes.objectOf(Promise).isRequired,
        setBannerData: PropTypes.func.isRequired
    };

    constructor(props){
        super(props);
        this.state = {
            alreadyInGlobalPool:  parseInt(sessionStorage.getItem('registeredToGlobalPool-' + this.props.customerName)) === 1
        };
    }

    render(){
        if (this.state['alreadyInGlobalPool']) {
            return (
                <div className="section-padding-bottom alice-bg flexHeight">
                    <div className="alice-bg padding-top-30 section-padding-bottom flexHeight2" style={getStyle(null, 'backgroundColor', this.props.customerName)}>
                        <div className="container">
                            <div className="job-listing-details job-detail-position">
                                <RegisterStepBreadCrumbs
                                    customerName={this.props.customerName}
                                    language={this.props.language}
                                    positionListLink={`/${this.props.language}/gate/${this.props.customerName}/positions`}
                                />
                                <div className={"row"}>
                                    <h4 className={"col-12 section-padding-30"}>{window.Translator.getSlug('AlreadyRegistered', this.props.language)}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <Register
                customerName={this.props.customerName}
                customerData={this.props.customerData}
                setBannerData={this.props.setBannerData}
                language={this.props.language}
            />
        );
    }

}
